import React from 'react';
import RolePermissionTable from './role_group_permission';

const UserPermissionTable = () => {
    return <RolePermissionTable defaultTab="2" />;
};

export default UserPermissionTable;
